import { useState, useEffect } from "react";
import { Modal, Form, Button } from "react-bootstrap";

export function ExplainerRecorder({onHide, show=true, explainer, videoMime, videoWidth, videoHeight}) {
    return (
        <Modal show={show} onHide={onHide} centered className="explainer-recorder-modal" size="xl">
            <Modal.Header closeButton closeVariant="white">
                <Modal.Title>Record Your Explainer</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="explainer-recorder-body" style={{overflow: "scroll", position: "relative",width: "100%", height: "100%", minHeight: "500px"}}>
                    <iframe src={explainer.url} style={{ width: videoWidth/window.devicePixelRatio, height: videoHeight/window.devicePixelRatio, position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} id={`explainer-recorder-iframe-${explainer.id}`}
                    onLoad={()=>{setTimeout(()=>{
                        const iframe = document.getElementById(`explainer-recorder-iframe-${explainer.id}`);
                        if (iframe) {
                            iframe.contentWindow.postMessage({
                                description: "RecordVideo",
                                result: {
                                    videoMime: videoMime,
                                }
                            }, "*");
                        }
                    }, 30)}}
                    />
                    <div style={{backgroundColor: "rgba(255,255,255,0.75)", zIndex:1, position: "absolute", top: 0, left: 0, maxWidth: "33%"}}>
                        <ul>
                            <li>Click the red record button to start recording</li>
                            <li>The explainer will have a red border around that indicates it is being recorded</li>
                            <li>Audio and music tracks will be in the recorded video, but may not be audible during the recording</li>
                            <li>The recording will automatically stop when the explainer is finished</li>
                            <li>Depending on your browser settings, the recording will be saved automatically or you will need to manually save it</li>
                            <li>This textbox will not be in the recording</li>
                        </ul>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

const VideoOptions = [
    { mime: "video/mp4", width: 1920, height: 1080 },
    { mime: "video/webm", width: 1920, height: 1080 },
    { mime: "video/ogg", width: 1920, height: 1080 },
    { mime: "video/mp4", width: 1024, height: 768 },
    { mime: "video/webm", width: 1024, height: 768 },
    { mime: "video/ogg", width: 1024, height: 768 },
]

export function getVideoOptions() {
    let t = [];
    for (const option of VideoOptions) {
        if (MediaRecorder?.isTypeSupported?.(option.mime)) {
            t.push(option);
        }
    }
    return t;
}